import apiService from '@/member/services/apiService'

const getDefaultState = () => {
  return {
    simulationList: {},
  }
}

const state = getDefaultState()

const mutations = {}

const actions = {
  async paginate({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.organization.paginate'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async getDetail({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.organization.detail'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async create({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.organization.create'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async update({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.organization.update'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async delete({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.organization.delete'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
}

export default {
  state,
  mutations,
  actions,
}
